<div
  class="spinner d-flex flex-column justify-content-center align-items-center"
  [class.spinner__full-height]="fullHeight">
  <core-svg svg="loading" [style.height.px]="diameter" [style.width.px]="diameter"></core-svg>
</div>
